import { tv } from 'tailwind-variants'

import { h4 } from '@ui-kit/core/typography'

export const tableCategoryAccordion = tv({
  slots: {
    row: 'flex cursor-pointer flex-row items-center justify-between bg-grey-200 p-4 hover:opacity-70 active:opacity-70 web:transition web:duration-300',
    title: h4(),
    icon: 'transition-all duration-300',
  },
  variants: {
    isLast: {
      false: { row: 'border-b-solid border-b border-b-grey-300' },
      true: { row: 'border-b-0' },
    },
    isExpanded: {
      true: {
        icon: 'rotate-180',
      },
    },
  },
  defaultVariants: {
    isLast: false,
  },
})
